import React, { useMemo, useState } from 'react';
import { FaUsers } from "react-icons/fa";
import { getMentionableUsers } from '../../utils/chatUtils';
import { useExamContext } from '../../context/ExamContext';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import './Chat.css';

export default function ChatPanel({
  isOpen,
  messages,
  setMessages,
  currentUserId,
  users,
  highlightMessageIds = [],
  justOpenedWithMentions,
  loading = false,
  error = null,
}) {
  const [replyTo, setReplyTo] = useState(null);
  const [sending, setSending] = useState(false);
  const ctx = useExamContext();
  const currentUserRole = ctx?.decoded ? (ctx.role ?? ctx.decoded.role) : null;
  const currentUserFromList = users.find((u) => String(u.id) === String(currentUserId));
  const currentUser = currentUserFromList ?? (currentUserId != null && currentUserRole
    ? { id: currentUserId, role: currentUserRole, name: ctx?.userName ?? ctx?.decoded?.user_name ?? 'Me', avatar: null }
    : null);
  const mentionableUsers = useMemo(() => getMentionableUsers(currentUser, users), [currentUser, users]);

  const handleMessageSent = (sent) => {
    setMessages((prev) => [...prev, sent]);
    setReplyTo(null);
  };

  if (!isOpen) return null;
    // Always define studentCount so it's accessible below
    const studentCount = currentUserRole === 'staff'
      ? users.filter((u) => u.role === 'student').length
      : '';
  return (
    <div className="chat-panel flex flex-col">
      <div className="chat-panel-header flex items-center justify-between px-3 py-2 border-b border-white/10">
        <h6 className="m-0 font-semibold flex items-center gap-2">
          <FaUsers className="shrink-0" />
          Class Chat
        </h6>
        <span className="px-2 py-0.5 text-sm rounded-full bg-white/25 text-white">
          {loading ? '…' : `${studentCount} students`}
        </span>
      </div>
      {error ? (
        <div className="chat-panel-error text-center text-red-600 text-sm p-3">
          {error}
        </div>
      ) : null}
      <MessageList
        messages={messages}
        users={users}
        currentUserId={currentUserId}
        onReply={setReplyTo}
        highlightMessageIds={highlightMessageIds}
        scrollToHighlighted={justOpenedWithMentions}
      />
      <MessageInput
        onSend={handleMessageSent}
        replyTo={replyTo}
        onClearReply={() => setReplyTo(null)}
        currentUser={currentUser}
        users={users}
        mentionableUsers={mentionableUsers}
        disabled={sending}
      />
    </div>
  );
}
